import React, { Component } from 'react';
import ReactTable from 'react-table';

export default class Promos extends Component {

	constructor(){
		super()

		this.mongo = process.env.REACT_APP_MONGO;
		this.state = {
			promo_code: null,
			start_date: null,
			expiration_date: null,
			maxUsers: 0,
			totalUsers: 0,
			promo_length: 30,
			currentPromos: []
		}

		this.getCurrentPromos = this.getCurrentPromos.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.submit = this.submit.bind(this);
	}

	componentDidMount(){
		this.getCurrentPromos();
	}

	getCurrentPromos(){
		let mongoAPI = "https://api.mlab.com/api/1/databases/funily/collections/promos?apiKey=" + this.mongo

		fetch(mongoAPI)
		.then(function(response){
			return response.json();
		})
		.then(function(jsonRes){
			let { currentPromos } = this.state;
			currentPromos = jsonRes;
			this.setState({currentPromos})
		}.bind(this))
		.catch(err => console.log('error getting getCurrentPromos',err));

	}

	handleChange(e){
		let item = e.target.name;
		let val = e.target.value;

		switch(item){
			case 'promo_code':
				this.setState({'promo_code': val});
				break;
			case 'start_date':
				val = new Date(val).getTime() + 86400000;
				console.log(val);
				this.setState({'start_date': val});
				break;
			case 'expiration_date':
				val = new Date(val).getTime() + 86400000;
				console.log(val);
				this.setState({'expiration_date': val});
				break;
			case 'maxUsers':
				this.setState({'maxUsers': val});
				break;
			case 'promo_length':
				this.setState({promo_length: val})
				break;
		}

	}

	submit(e){
		e.preventDefault();
		let data = this.state;
		console.log(JSON.stringify(data));

		let mongoAPI = "https://api.mlab.com/api/1/databases/funily/collections/promos?apiKey=" + this.mongo

		fetch(mongoAPI,{
			//mode: 'no-cors',
			method: 'POST',
			headers:{
				Accept: 'application/json',
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(data)
		})
		.then(res => console.log(res))
		.catch(err => console.log('error adding promo code', err));

		e.target.reset();
		this.getCurrentPromos()

		this.setState({
			promo_code: null,
			start_date: null,
			expiration_date: null,
			maxUsers: 0,
			totalUsers: 0,
			promo_length: 30
		})
	}

	render() {
		let { currentPromos } = this.state;
		let columns = [
			{
				Header: 'Promo Code',
				accessor: 'promo_code'
			},
			{
				Header: 'Start Date',
				accessor: 'start_date',
				Cell: row => (<p>{new Date(row.original.start_date).toDateString()}</p>)
			},
			{
				Header: 'Expiration Date',
				accessor: 'expiration_date',
				Cell: row => (<p>{new Date(row.original.expiration_date).toDateString()}</p>)
			},
			{
				Header: 'Max Users',
				accessor: 'maxUsers'
			},
			{
				Header: 'Total Users',
				accessor: 'totalUsers'
			},
			{
				Header: 'Promo Length',
				accessor: 'promo_length',
				Cell: row => (<p>{row.original.promo_length + ' Days'}</p>)
			}

		]
		return (
			<div style={styles.container}>
				<div className='col-md-4 col-md-offset-4'>
					<form onSubmit={this.submit}>

						<div className='form-group'>
					        <input className='form-control' 
					        		type='text' 
					        		name='promo_code' 
					        		ref='promo_code' 
					        		placeholder='ENTER PROMO CODE'
					           		onChange={this.handleChange} 
					           		required
					        />
				        </div>

				        <div className='form-group'>
				        	<label>Start Date</label>
					        <input className='form-control' 
					        		type='date' 
					        		name='start_date' 
					        		ref='start_date'
					           		onChange={this.handleChange} 
					           		required
					        />
				        </div>

				        <div className='form-group'>
				        	<label>Expiration Date</label>
					        <input className='form-control' 
					        		type='date' 
					        		name='expiration_date' 
					        		ref='expiration_date'
					           		onChange={this.handleChange} 
					           		required
					        />
				        </div>

				        <div className='form-group'>
				        	<label>Max number of users</label>
					        <input className='form-control' 
					        		type='number' 
					        		name='maxUsers' 
					        		ref='maxUsers'
					        		min='1'
					        		value={this.state.maxUsers}
					           		onChange={this.handleChange} 
					           		required
					        />
				        </div>

				        <div className='form-group'>
				        	<label>Length of Promo (in days)</label>
					        <input className='form-control' 
					        		type='number' 
					        		name='promo_length' 
					        		ref='promo_length'
					        		min='1'
					        		value={this.state.promo_length}
					           		onChange={this.handleChange} 
					           		required
					        />
				        </div>

				        <button className='btn btn-success btn-block' type='submit'>Enter Promo</button>

					</form>
				</div>
				<div style={styles.tableCont}>
				{
					currentPromos.length > 0 ?
					<ReactTable 
						data={currentPromos}
						columns={columns}
						className="-striped -highlight"
					/>
					: null
				}
				</div>
			</div>
		);
	}
}

const styles = {
	container: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: "center",
		paddingTop: "20px",
		marginTop: 100
	},
	tableCont: {
		marginTop: '50px'
	}
}












// WEBPACK FOOTER //
// ./src/components/admin/Promos.js